<template>
  <div class="create-bookmark">
    <div class="create-bookmark__wrapper" v-show="showModal">
      <div class="create-bookmark__content">
        <div class="create-bookmark__content-wrapper">
          <div class="create-bookmark__header">
            <h6 class="create-bookmark__title">Create Bookmark</h6>
            <div class="create-bookmark__info">
              <h6 class="create-bookmark__video-title">
                <span class="create-bookmark__lead">Video:</span>
                {{ pendingBookmark.title }}
              </h6>
              <div class="create-bookmark__time">
                <span class="create-bookmark__time-lead">Time:</span>
                <input
                  @focus="invalidTime = false"
                  v-model="time"
                  v-on:keyup="validateTime()"
                  :class="
                    invalidTime
                      ? 'create-bookmark__error-in-form create-bookmark__form-control create-bookmark__time-input'
                      : 'create-bookmark__form-control create-bookmark__time-input'
                  "
                />
                <small
                  class="create-bookmark__invalid-time"
                  v-show="invalidTime"
                  >* Incorrect time input</small
                >
              </div>
            </div>
          </div>
          <div
            class="create-bookmark__form-group create-bookmark__video-description-entry"
          >
            <p>Enter Notes for This Bookmark:</p>
            <textarea
              @focus="invalidDescription = false"
              :class="
                invalidDescription
                  ? 'create-bookmark__error-in-form create-bookmark__form-control'
                  : 'create-bookmark__form-control'
              "
              v-model="description"
              rows="3"
            ></textarea>
            <small
              class="create-bookmark__invalid-warning"
              v-show="invalidDescription"
              >* Notes are required</small
            >
          </div>
          <div class="create-bookmark__button-group">
            <button @click="closeModal()" class="create-bookmark__cancel-btn">
              Cancel
            </button>
            <button
              @click="createBookmark()"
              class="create-bookmark__confirm-btn"
              ref="confirmBtn"
            >
              Save
            </button>
          </div>
        </div>
        <div v-show="showConfirmation" class="create-bookmark__success-mask">
          <div class="create-bookmark__success-positioning">
            <div class="create-bookmark__success-wrapper">
              <h6 class="create-bookmark__success">Bookmark Saved!</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CreateBookmarkModal',
  data() {
    return {
      showModal: true,
      description: '',
      showConfirmation: false,
      invalidDescription: false,
      invalidTime: false,
      time: 0,
    }
  },
  computed: {
    ...mapGetters({
      pendingBookmark: 'user/pendingBookmark',
      userId: 'auth/userId',
    }),
  },
  methods: {
    async createBookmark() {
      if (this.description === '') {
        this.invalidDescription = true
        return
      }
      const bookmark = {
        course_id: this.pendingBookmark.course_id,
        title: this.description,
        time: this.time === 0 ? 0 : this.$duration.convertToSeconds(this.time),
        user_id: this.userId,
        video_id: this.pendingBookmark.video_id,
      }
      if (!this.invalidDescription && !this.invalidTime) {
        this.$refs.confirmBtn.disabled = true
        await this.$store.dispatch('user/postUserVideoBookmark', bookmark)
        this.showConfirmation = true
        setTimeout(() => {
          this.showConfirmation = false
          this.closeModal()
        }, 1500)
      }
    },
    validateTime() {
      const regex = new RegExp('([0-1][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])')
      if (!regex.test(this.time)) {
        this.$refs.confirmBtn.disabled = true
        this.invalidTime = true
      } else {
        this.$refs.confirmBtn.disabled = false
        this.invalidTime = false
      }
    },
    closeModal() {
      this.showModal = false
      this.$emit('resumeVideo')
      this.$emit('closed', true)
    },
  },
  created() {
    this.time = this.$duration.hhmmss(this.pendingBookmark.time)
  },
}
</script>

<style lang="scss" scoped>
.create-bookmark {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
  &__wrapper {
    display: table-cell;
    vertical-align: middle;
    position: relative;
  }
  &__content {
    margin: 0px auto;
    background-color: var(--light-gray);
    color: var(--white);
    max-width: 550px;
    min-height: 400px;
  }
  &__content-wrapper {
    display: flex;
    flex-wrap: wrap;
  }
  &__header {
    padding: 20px;
  }
  &__title {
    text-align: center;
    margin: 0 auto;
    font-size: 1.5rem;
    padding-bottom: 10px;
    border-bottom: 1px solid var(--orange);
  }
  &__info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding: 20px;
  }
  &__video-title {
    color: var(--orange);
    margin: 0 0 20px 0;
    width: 100%;
  }
  &__lead {
    color: var(--gray);
  }
  &__time {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__time-lead {
    font-size: 1.25rem;
    margin-right: 10px;
    color: var(--gray);
  }
  &__time-input {
    text-align: center;
  }
  &__error-in-form {
    border: 1px solid var(--red);
  }
  &__invalid-time {
    color: var(--red);
    position: absolute;
    margin-top: 30px;
    margin-left: 55px;
  }
  &__video-description-entry {
    padding: 0px 25px 20px 25px;
    width: 100%;
  }
  &__form-control {
    width: 100%;
  }
  &__invalid-warning {
    height: 10px;
    color: var(--red);
  }
  &__button-group {
    display: flex;
    justify-content: flex-end;
    font-size: 1rem;
    padding-bottom: 20px;
    padding-right: 20px;
    width: 100%;
  }
  &__confirm-btn {
    color: var(--white);
    transition: all 0.5s ease;
    margin-left: 10px;
    border: 1px solid var(--white);
    color: green;
    padding: 2px 20px;
    &:hover {
      cursor: pointer;
      background-color: var(--green);
      color: var(--white);
    }
  }
  &__cancel-btn {
    border: none;
    background: none;
    text-decoration: underline;
    color: var(--white);
    transition: all 0.5s ease;
    &:hover {
      cursor: pointer;
      color: var(--red);
    }
  }
  &__success-mask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
  }
  &__success-positioning {
    display: table-cell;
    vertical-align: middle;
    position: relative;
    margin: 0 auto;
  }
  &__success-wrapper {
    background-color: var(--light-gray);
    padding-left: 50px;
    padding-right: 50px;
    padding-bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    width: 100%;
    @include mobile {
      width: 30%;
    }
  }
  &__success {
    color: var(--white);
    font-size: 2rem;
    padding: 50px;
    padding-bottom: 20px;
    margin: 0 auto;
    text-align: center;
  }
}
</style>
